module.exports = __webpack_public_path__ + "static/vib_play6s-fa124bea86083dabefa27bd0848811ee.jpg";